import { render } from "./NotFound.vue?vue&type=template&id=0a998c1b"
const script = {}

import exportComponent from "/Users/elliot/Documents/attendance-systems/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__